import { loadScript } from '@/utils/loadScript'

const TURNSTILE_SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
const TURNSTILE_SCRIPT_TIMEOUT_MS = 10000

export async function loadTurnstile(): Promise<typeof window.turnstile> {
    if (window.turnstile) {
        return window.turnstile
    }
    await loadScript({
        src: TURNSTILE_SCRIPT_URL,
        scriptName: 'Turnstile',
        timeoutMs: TURNSTILE_SCRIPT_TIMEOUT_MS,
        useExisting: true,
    })
    return window.turnstile
}
